(function() {
  'use strict';

  /* ── Configuration ── */
  var config = window.SlStoreConfig;
  var strip = window.SlStripProduct;

  if (!config || !config.storefrontToken || !config.storeUrl) return;
  if (!strip || !strip.wattsPerMetre) return;

  /* ── DOM references ── */
  var lengthInput = document.getElementById('lsc-length');
  var lengthHelper = document.getElementById('lsc-length-helper');
  var lengthError = document.getElementById('lsc-length-error');
  var step2 = document.getElementById('lsc-step-2');
  var dimmingTypePanel = document.getElementById('lsc-dimming-type');
  var dimmingSelect = document.getElementById('lsc-dimming-select');
  var searchBtn = document.getElementById('lsc-search-btn');
  var step3 = document.getElementById('lsc-step-3');
  var resultsDivider = document.getElementById('lsc-results-divider');
  var resultsContainer = document.getElementById('lsc-results');
  var resultsHeading = document.getElementById('lsc-results-heading');
  var calcSummary = document.getElementById('lsc-calc-summary');
  var resultsStepLabel = document.getElementById('lsc-results-step-label');
  var totalStepsSpan = document.getElementById('lsc-total-steps');
  var totalStepsSpans = document.querySelectorAll('.lsc-total-steps');
  var optionCards = document.querySelectorAll('.lsc__option-card');
  var trigger = document.getElementById('lsc-trigger');
  var panel = document.getElementById('lsc-panel');

  if (!lengthInput || !searchBtn) return;

  /* ── State ── */
  var state = {
    length: null,
    dimmingChoice: null,    /* 'none' | 'yes' */
    dimmingType: null,      /* 'pwm' | 'triac' | 'dali' | 'tuya' | null */
    isDimmable: strip.isDimmable === true || strip.isDimmable === 'true'
  };

  var totalSteps = state.isDimmable ? 3 : 2;

  /* ── Initialise ── */
  function init() {
    /* Set step counts */
    if (totalStepsSpan) totalStepsSpan.textContent = totalSteps;
    totalStepsSpans.forEach(function(el) { el.textContent = totalSteps; });

    /* Set max length helper */
    if (strip.maxLengthM && lengthHelper) {
      lengthHelper.textContent = 'Maximum run for this strip: ' + strip.maxLengthM + 'm';
    }

    /* Set input constraints */
    if (strip.maxLengthM) lengthInput.max = strip.maxLengthM;
    if (strip.cutIncrementMm) {
      lengthInput.step = (strip.cutIncrementMm / 1000).toString();
    }

    /* Hide dimming step if not dimmable */
    if (!state.isDimmable) {
      step2.hidden = true;
      /* Update step 3 indicator */
      if (resultsStepLabel) resultsStepLabel.textContent = 'Step 2 of 2';
    } else {
      if (resultsStepLabel) resultsStepLabel.textContent = 'Step 3 of 3';
    }

    bindEvents();
  }

  /* ── Events ── */
  function bindEvents() {
    lengthInput.addEventListener('input', onLengthChange);
    lengthInput.addEventListener('blur', onLengthBlur);

    optionCards.forEach(function(card) {
      card.addEventListener('click', onDimmingCardClick);
    });

    if (dimmingSelect) {
      dimmingSelect.addEventListener('change', onDimmingSelectChange);
    }

    searchBtn.addEventListener('click', onSearch);

    /* Add-to-cart event delegation */
    resultsContainer.addEventListener('click', function(e) {
      var btn = e.target.closest('.lsc__add-to-cart');
      if (btn) addToCart(btn);
    });

    /* Accordion toggle */
    if (trigger && panel) {
      trigger.addEventListener('click', togglePanel);
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && trigger.getAttribute('aria-expanded') === 'true') {
          closePanel();
          trigger.focus();
        }
      });
    }
  }

  /* ── Accordion ── */
  function togglePanel() {
    var isOpen = trigger.getAttribute('aria-expanded') === 'true';
    if (isOpen) {
      closePanel();
    } else {
      openPanel();
    }
  }

  function openPanel() {
    trigger.setAttribute('aria-expanded', 'true');
    panel.classList.add('lsc__panel--open');
    panel.style.maxHeight = panel.scrollHeight + 'px';

    /* Scroll trigger into view if partially off screen */
    setTimeout(function() {
      var rect = trigger.getBoundingClientRect();
      if (rect.top < 0) {
        trigger.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 50);

    /* Update max-height after content changes (e.g. results loading) */
    panel.addEventListener('transitionend', function onEnd() {
      if (trigger.getAttribute('aria-expanded') === 'true') {
        panel.style.maxHeight = 'none';
      }
      panel.removeEventListener('transitionend', onEnd);
    });
  }

  function closePanel() {
    /* Set explicit height first so transition works from a value */
    panel.style.maxHeight = panel.scrollHeight + 'px';
    /* Force reflow */
    panel.offsetHeight;
    panel.style.maxHeight = '0';
    panel.classList.remove('lsc__panel--open');
    trigger.setAttribute('aria-expanded', 'false');
  }

  function onLengthChange() {
    clearError();
    validateAndUpdateState();
  }

  function onLengthBlur() {
    var val = parseFloat(lengthInput.value);
    if (lengthInput.value !== '' && !isNaN(val)) {
      validateLength(val);
    }
    validateAndUpdateState();
  }

  function onDimmingCardClick(e) {
    var card = e.currentTarget;
    var value = card.getAttribute('data-dimming');

    /* Update aria-pressed */
    optionCards.forEach(function(c) {
      c.setAttribute('aria-pressed', 'false');
    });
    card.setAttribute('aria-pressed', 'true');

    state.dimmingChoice = value;

    if (value === 'yes') {
      dimmingTypePanel.hidden = false;
      state.dimmingType = dimmingSelect.value || null;
    } else {
      dimmingTypePanel.hidden = true;
      state.dimmingType = 'none';
    }

    validateAndUpdateState();
  }

  function onDimmingSelectChange() {
    state.dimmingType = dimmingSelect.value || null;
    validateAndUpdateState();
  }

  /* ── Validation ── */
  function validateLength(val) {
    if (val < 0.1) {
      showError('Minimum length is 0.1m');
      return false;
    }
    if (strip.maxLengthM && val > parseFloat(strip.maxLengthM)) {
      showError('Maximum run for this strip is ' + strip.maxLengthM + 'm');
      return false;
    }
    clearError();
    return true;
  }

  function showError(msg) {
    lengthError.textContent = msg;
    lengthError.hidden = false;
    var wrap = lengthInput.closest('.lsc__input-wrap');
    if (wrap) wrap.classList.add('lsc__input-wrap--error');
  }

  function clearError() {
    lengthError.textContent = '';
    lengthError.hidden = true;
    var wrap = lengthInput.closest('.lsc__input-wrap');
    if (wrap) wrap.classList.remove('lsc__input-wrap--error');
  }

  function validateAndUpdateState() {
    var val = parseFloat(lengthInput.value);
    var lengthValid = !isNaN(val) && val >= 0.1 && (!strip.maxLengthM || val <= parseFloat(strip.maxLengthM));
    state.length = lengthValid ? val : null;

    /* Determine if search is enabled */
    var canSearch = false;
    if (state.length) {
      if (!state.isDimmable) {
        /* No dimming step — length is sufficient */
        canSearch = true;
      } else if (state.dimmingChoice === 'none') {
        canSearch = true;
      } else if (state.dimmingChoice === 'yes' && state.dimmingType) {
        canSearch = true;
      }
    }

    searchBtn.disabled = !canSearch;
  }

  /* ── Search ── */
  function onSearch() {
    if (searchBtn.disabled) return;

    /* Read strip voltage from data attribute (integer) */
    var configuratorEl = document.getElementById('led-strip-configurator');
    var stripVoltage = parseInt(configuratorEl.getAttribute('data-strip-voltage')) || parseInt(strip.voltage) || 0;

    /* Calculate wattage — divide by 0.8 to get 80% headroom */
    var requiredWatts = state.length * parseFloat(strip.wattsPerMetre);
    var minimumDriverWatts = Math.ceil(requiredWatts / 0.8);

    /* Show results section */
    step3.hidden = false;
    resultsDivider.hidden = false;

    /* Show calculation summary */
    var summaryHtml = '<strong>' + state.length + 'm</strong> × <strong>' + strip.wattsPerMetre + 'W/m</strong> = <strong>' + requiredWatts.toFixed(1) + 'W</strong> required';
    summaryHtml += '<br>We recommend a driver rated at least <strong>' + minimumDriverWatts + 'W</strong>. Running at 80% capacity ensures reliability and extends driver lifespan.';
    calcSummary.innerHTML = summaryHtml;

    /* Show loading state */
    resultsContainer.setAttribute('aria-busy', 'true');
    resultsContainer.innerHTML = '<div class="lsc__loading"><div class="lsc__spinner"></div>Searching for compatible drivers…</div>';

    /* Focus results heading */
    resultsHeading.focus();

    /* Query Storefront API */
    fetchDrivers(minimumDriverWatts, stripVoltage);
  }

  /* ── Storefront API ── */
  function fetchDrivers(minimumDriverWatts, stripVoltage) {
    try {
    var storeUrl = config.storeUrl.replace(/^https?:\/\//, '');
    var endpoint = 'https://' + storeUrl + '/api/2025-10/graphql.json';

    var query = '{\n' +
      '  collection(handle: "led-drivers") {\n' +
      '    products(first: 50) {\n' +
      '      edges {\n' +
      '        node {\n' +
      '          id\n' +
      '          title\n' +
      '          handle\n' +
      '          priceRange {\n' +
      '            minVariantPrice {\n' +
      '              amount\n' +
      '              currencyCode\n' +
      '            }\n' +
      '          }\n' +
      '          images(first: 1) {\n' +
      '            edges {\n' +
      '              node {\n' +
      '                url\n' +
      '                altText\n' +
      '              }\n' +
      '            }\n' +
      '          }\n' +
      '          variants(first: 2) {\n' +
      '            edges {\n' +
      '              node {\n' +
      '                id\n' +
      '              }\n' +
      '            }\n' +
      '          }\n' +
      '          metafields(identifiers: [\n' +
      '            {namespace: "custom", key: "driver_voltage"},\n' +
      '            {namespace: "custom", key: "driver_max_watts"},\n' +
      '            {namespace: "custom", key: "is_dimmable"}\n' +
      '          ]) {\n' +
      '            key\n' +
      '            value\n' +
      '          }\n' +
      '        }\n' +
      '      }\n' +
      '    }\n' +
      '  }\n' +
      '}';

    fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': config.storefrontToken
      },
      body: JSON.stringify({ query: query })
    })
    .then(function(res) {
      if (!res.ok) throw new Error('API request failed: ' + res.status);
      return res.json();
    })
    .then(function(data) {
      if (data.errors) {
        console.error('[DRIVER] GraphQL errors:', data.errors);
        throw new Error('GraphQL errors');
      }
      if (!data.data.collection) {
        console.error('[DRIVER] Collection "led-drivers" not found');
        throw new Error('Collection not found');
      }
      var products = data.data.collection.products.edges.map(function(e) { return e.node; });

      var filtered = filterDrivers(products, minimumDriverWatts, stripVoltage);

      /* Cap oversized drivers — exclude anything > 3× minimum */
      var maxCap = minimumDriverWatts * 3;
      filtered = filtered.filter(function(d) {
        if (d._maxWatts > maxCap) {
          return false;
        }
        return true;
      });

      renderResults(filtered);
    })
    .catch(function(err) {
      console.error('[DRIVER] Error:', err);
      resultsContainer.setAttribute('aria-busy', 'false');
      resultsContainer.innerHTML = '<div class="lsc__api-error">' +
        'Sorry, we couldn\'t load driver recommendations right now.<br>' +
        '<a href="/pages/contact">Contact us</a> and we\'ll help you choose the right driver.' +
        '</div>';
    });
    } catch (err) {
      console.error('[DRIVER] Sync error:', err);
    }
  }

  /* ── Filter & Sort ── */
  function filterDrivers(products, minimumDriverWatts, stripVoltage) {
    var matched = [];

    products.forEach(function(product) {
      var mf = {};
      if (product.metafields) {
        product.metafields.forEach(function(m) {
          if (m && m.key) mf[m.key] = m.value;
        });
      }

      /* Parse driver_voltage — it's a list of integers like "[12,24]" */
      var driverVoltages = [];
      if (mf.driver_voltage) {
        try {
          driverVoltages = JSON.parse(mf.driver_voltage);
          if (!Array.isArray(driverVoltages)) driverVoltages = [driverVoltages];
        } catch (e) {
          /* Fallback: try single integer */
          var parsed = parseInt(mf.driver_voltage);
          if (!isNaN(parsed)) driverVoltages = [parsed];
        }
      }

      /* Voltage must match — driver must support the strip's voltage */
      var voltageMatch = driverVoltages.indexOf(stripVoltage) !== -1;
      if (!voltageMatch) {
        return;
      }

      /* Wattage must be sufficient */
      var maxWatts = parseInt(mf.driver_max_watts) || 0;
      if (maxWatts < minimumDriverWatts) {
        return;
      }

      /* Parse dimmable flag */
      var isDimmable = mf.is_dimmable === 'true' || mf.is_dimmable === true;

      /* Store parsed values for sorting/rendering */
      product._mf = mf;
      product._maxWatts = maxWatts;
      product._isDimmable = isDimmable;

      matched.push(product);
    });

    /* Sort by wattage ascending (closest match first) */
    matched.sort(function(a, b) {
      return a._maxWatts - b._maxWatts;
    });

    return matched;
  }

  /* ── Render ── */
  function renderResults(drivers) {
    resultsContainer.setAttribute('aria-busy', 'false');

    if (drivers.length === 0) {
      resultsContainer.innerHTML = '<div class="lsc__no-results">' +
        'No drivers found for this configuration.<br>' +
        '<a href="/pages/contact">Please contact us</a> for advice on the right driver.' +
        '</div>';
      return;
    }

    /* Split into groups, cap each at 3 (already sorted by wattage ascending) */
    var nonDimmableDrivers = drivers.filter(function(d) { return !d._isDimmable; }).slice(0, 3);
    var dimmableDrivers = drivers.filter(function(d) { return d._isDimmable; }).slice(0, 3);

    var html = '';

    /* Non-dimmable section first */
    if (nonDimmableDrivers.length > 0) {
      html += '<h4 class="lsc__results-section-heading">Non-Dimmable Drivers (' + nonDimmableDrivers.length + ')</h4>';
      html += '<div class="lsc__results-list">';
      nonDimmableDrivers.forEach(function(d) { html += renderDriverCard(d); });
      html += '</div>';
    }

    /* Dimmable section second */
    if (dimmableDrivers.length > 0) {
      html += '<h4 class="lsc__results-section-heading">Dimmable Drivers (' + dimmableDrivers.length + ')</h4>';
      html += '<div class="lsc__results-list">';
      dimmableDrivers.forEach(function(d) { html += renderDriverCard(d); });
      html += '</div>';
    }

    /* View all link */
    html += '<p class="lsc__view-all">Need a different size or type? <a href="/collections/led-drivers">View all LED drivers \u2192</a></p>';

    resultsContainer.innerHTML = html;
  }

  /* ── Render a single driver card ── */
  function renderDriverCard(driver) {
    var image = driver.images.edges.length > 0 ? driver.images.edges[0].node : null;
    var price = driver.priceRange.minVariantPrice;
    var priceFormatted = '\u00A3' + parseFloat(price.amount).toFixed(2);
    var variants = driver.variants ? driver.variants.edges : [];
    var isSingleVariant = variants.length === 1;

    var html = '<div class="lsc__driver-card">';

    /* Image */
    if (image && image.url) {
      html += '<img class="lsc__driver-img" src="' + image.url + '&width=160" alt="' + escapeHtml(image.altText || driver.title) + '" width="80" height="80" loading="lazy">';
    } else {
      html += '<div class="lsc__driver-img-placeholder"><svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="m21 15-5-5L5 21"/></svg></div>';
    }

    /* Info */
    html += '<div class="lsc__driver-info">';
    html += '<p class="lsc__driver-title">' + escapeHtml(driver.title) + '</p>';
    html += '<div class="lsc__driver-badges">';
    if (driver._maxWatts) {
      html += '<span class="lsc__badge">' + driver._maxWatts + 'W</span>';
    }
    if (driver._isDimmable) {
      html += '<span class="lsc__badge">Dimmable</span>';
    }
    html += '</div>';
    html += '<p class="lsc__driver-price">' + priceFormatted + ' <span style="font-size:0.6875rem;color:#6b7280;">inc. VAT</span></p>';
    html += '</div>';

    /* Action */
    html += '<div class="lsc__driver-action">';
    if (isSingleVariant) {
      var variantId = variants[0].node.id.split('/').pop();
      html += '<button type="button" class="lsc__add-to-cart" data-variant-id="' + variantId + '">Add to Basket</button>';
    } else {
      html += '<button type="button" class="lsc__choose-options" data-quick-add data-handle="' + driver.handle + '" data-variants-count="2">Choose options \u2192</button>';
    }
    html += '</div>';

    html += '</div>';
    return html;
  }

  /* ── Add to Cart ── */
  /* Collect cart-items-component section IDs so /cart/add.js returns rendered
     drawer HTML in the response. cart-items-component morphs from that payload
     BEFORE the open animation runs. Mirrors product-form.js:512. */
  function getCartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function(el) {
      if (el.dataset && el.dataset.sectionId) ids.push(el.dataset.sectionId);
    });
    return ids.join(',');
  }

  function addToCart(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId || btn.disabled) return;

    btn.disabled = true;
    btn.textContent = 'Adding\u2026';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: parseInt(variantId, 10),
        quantity: 1,
        sections: getCartSectionIds()
      })
    })
    .then(function(res) {
      if (!res.ok) throw new Error('Add to cart failed');
      return res.json();
    })
    .then(function(response) {
      btn.textContent = 'Added \u2713';
      btn.classList.add('lsc__add-to-cart--success');

      /* Dispatch cart:update with sections INSIDE detail.data (sibling of
         source/itemCount) so cart-items-component reads detail.data.sections
         and morphs the drawer subtree synchronously. Then open the drawer.
         Order matters: dispatch first (morph), open second (animate). */
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          data: {
            source: 'product-form-component',
            itemCount: 1,
            sections: response.sections
          }
        }
      }));

      var cartDrawer = document.querySelector('cart-drawer-component');
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      }

      setTimeout(function() {
        btn.textContent = 'Add to Basket';
        btn.classList.remove('lsc__add-to-cart--success');
        btn.disabled = false;
      }, 2000);
    })
    .catch(function() {
      btn.textContent = 'Error \u2014 try again';
      btn.classList.add('lsc__add-to-cart--error');
      btn.disabled = false;
      setTimeout(function() {
        btn.textContent = 'Add to Basket';
        btn.classList.remove('lsc__add-to-cart--error');
      }, 3000);
    });
  }

  /* ── Utilities ── */
  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  /* ── Start ── */
  init();
})();
